/* This file was generated automatically. Do not edit manually. */

export enum MailTemplateType {
    Quotation = 'Quotation',
    Confirmation = 'Confirmation',
    AfterEnd = 'AfterEnd',
    ReleaseReminder = 'ReleaseReminder',
    Cancellation = 'Cancellation',
    AfterStart = 'AfterStart',
    BookerConfirmation = 'BookerConfirmation',
    CheckOutInvitation = 'CheckOutInvitation',
    BeforeStart = 'BeforeStart',
    BeforeStartReminder = 'BeforeStartReminder',
    CompanionInvitation = 'CompanionInvitation',
    BillSent = 'BillSent',
    PaymentRequestAdded = 'PaymentRequestAdded',
    ChargePreauthorizationSuccess = 'ChargePreauthorizationSuccess',
    AutomaticSettlementFailure = 'AutomaticSettlementFailure',
    ChargeSuccess = 'ChargeSuccess',
    ChargeFailure = 'ChargeFailure',
    PaymentAuthorizationCardPayment = 'PaymentAuthorizationCardPayment',
    PaymentAuthorizationPreauthorization = 'PaymentAuthorizationPreauthorization',
    UnreadMessageNotification = 'UnreadMessageNotification',
    PaymentAuthorizationFailure = 'PaymentAuthorizationFailure',
    BookingAbandoned = 'BookingAbandoned',
    GuestEmailVerified = 'GuestEmailVerified',
    SignInLink = 'SignInLink',
    VerificationCode = 'VerificationCode',
    InvoiceReminder = 'InvoiceReminder',
    BulkInvoiceReminder = 'BulkInvoiceReminder',
}
